import type * as Types from '../../types';

import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import document from './signInWithSocialCodeMutation.gql';
import { EatSessionFragmentDoc } from '../../fragments/eat/EatSessionFragment.generated';
import type * as ApolloReactCommon from '~/lazy_apollo/client';
import * as ApolloReactHooks from '~/lazy_apollo/client';
const defaultOptions = {} as const;
export type SignInWithSocialCodeMutation_signInWithSocialCode_SocialSignInPayload_session_Session_user_User = {
  __typename: 'User',
  id: number,
  avatarUrl?: string | null,
  displayName: string,
  email?: string | null,
  firstName?: string | null
};

export type SignInWithSocialCodeMutation_signInWithSocialCode_SocialSignInPayload_session_Session = {
  __typename: 'Session',
  id: string,
  user?: SignInWithSocialCodeMutation_signInWithSocialCode_SocialSignInPayload_session_Session_user_User | null
};

export type SignInWithSocialCodeMutation_signInWithSocialCode_SocialSignInPayload = {
  __typename: 'SocialSignInPayload',
  isNewAccount: boolean,
  session: SignInWithSocialCodeMutation_signInWithSocialCode_SocialSignInPayload_session_Session
};

export type SignInWithSocialCodeMutation_Mutation = {
  __typename?: 'Mutation',
  signInWithSocialCode: SignInWithSocialCodeMutation_signInWithSocialCode_SocialSignInPayload
};


export type SignInWithSocialCodeMutationVariables = Types.Exact<{
  appleCode?: Types.InputMaybe<Types.Scalars['String']['input']>;
  facebookCode?: Types.InputMaybe<Types.Scalars['String']['input']>;
  googleCode?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type SignInWithSocialCodeMutation = SignInWithSocialCodeMutation_Mutation;


export const SignInWithSocialCodeDocument = /*#__PURE__*/ document as unknown as DocumentNode<SignInWithSocialCodeMutation, SignInWithSocialCodeMutationVariables>;

export type SignInWithSocialCodeMutationFn = ApolloReactCommon.MutationFunction<SignInWithSocialCodeMutation, SignInWithSocialCodeMutationVariables>;

/**
 * __useSignInWithSocialCodeMutation__
 *
 * To run a mutation, you first call `useSignInWithSocialCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignInWithSocialCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signInWithSocialCodeMutation, { data, loading, error }] = useSignInWithSocialCodeMutation({
 *   variables: {
 *      appleCode: // value for 'appleCode'
 *      facebookCode: // value for 'facebookCode'
 *      googleCode: // value for 'googleCode'
 *   },
 * });
 */
export function useSignInWithSocialCodeMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SignInWithSocialCodeMutation, SignInWithSocialCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SignInWithSocialCodeMutation, SignInWithSocialCodeMutationVariables>(SignInWithSocialCodeDocument, options);
      }
export type SignInWithSocialCodeMutationHookResult = ReturnType<typeof useSignInWithSocialCodeMutation>;
export type SignInWithSocialCodeMutationResult = ApolloReactCommon.MutationResult<SignInWithSocialCodeMutation>;
export type SignInWithSocialCodeMutationOptions = ApolloReactCommon.BaseMutationOptions<SignInWithSocialCodeMutation, SignInWithSocialCodeMutationVariables>;